import { render, staticRenderFns } from "./EmailTemplateList.vue?vue&type=template&id=0e1a965e&scoped=true"
import script from "./EmailTemplateList.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a965e",
  null
  
)

export default component.exports